import React from "react";

const ProgressBar = (props) => {
  //   const [isVisible, setIsVisible] = useState(0);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  //   useEffect(() => {
  //     const amountList = props.milestones.map((value) => {
  //       return {
  //         amount: value.amount.value,
  //       };
  //     });

  //     let result = amountList.map((a) => a.amount);

  //     const nextNumber = (element) => element > props.raised;

  //     setIsVisible(result.findIndex(nextNumber));
  //   }, [props.milestones, props.raised]);

  //   const toggle = (i) => {
  //     if (isVisible === i) setIsVisible(null);
  //     else setIsVisible(i);
  //   };

  return (
    <div className="progress_wrapper">
      <section className="inner-row gutters constrain overlay_lp__content progress">
        <div className="col-12">
          <div className="progress_wrapper__therm">
            <div
              className="progress_wrapper__therm__inner"
              style={{
                width: `${props.progress + 0.5}%`,
              }}
            ></div>
          </div>
        </div>
        {/* <div className="col-1"></div> */}
        <div className="col-12">
          {/* <div className="progress_wrapper__text">
            <p>DrLupo's community has raised...</p>
          </div> */}
          <span className="progress_wrapper__raised">
            {formatter.format(props.raised)} Raised
          </span>
          <span className="progress_wrapper__goal">
            Goal:{" "}
            {props.goal - Math.floor(props.goal) !== 0
              ? formatter.format(props.goal)
              : "$" + formatNumber(props.goal)}
          </span>
        </div>
        {/* <div className="col-1"></div> */}
      </section>
    </div>
  );
};

export default ProgressBar;
